import { CONTRACT_BASE_URL } from "../../../constants";
import { getToken, isLoggedIn } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { CONFIG_PATH } from "./constants";
import { IConfigResponseData } from "./models";

const appProvide = async () => AuthConfig.getAppToken();
const defaultProvide = async () => await getToken();

export const getConfigs = (): Promise<IConfigResponseData> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${CONFIG_PATH}`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor, null);
};

export const setConfig = (body: any): Promise<any> => {
  const descriptor = new ApiServiceManager(
    `${CONTRACT_BASE_URL}${CONFIG_PATH}`,
    "POST",
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
